"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var BrowserInfo = (function (_super) {
    __extends(BrowserInfo, _super);
    function BrowserInfo(cache, window) {
        var _this = _super.call(this, cache) || this;
        _this.window = window;
        _this.deviceType = 'DESKTOP';
        _this.deviceVersion = _this.window.navigator.userAgent;
        _this.deviceBrand = _this.window.navigator.vendor;
        _this.browserName = _this.window.navigator.userAgent;
        _this.browserVersion = _this.window.navigator.userAgent;
        _this.deviceModel = _this.window.navigator.platform;
        _this.deviceManufacturer = _this.window.navigator.vendor;
        _this.operatingSystemName = _this.window.navigator.platform;
        _this.operatingSystemVersion = _this.window.navigator.appVersion;
        _this.userFriendlyName = _this.window.navigator.appName;
        return _this;
    }
    return BrowserInfo;
}(client_lib_js_player_addons_common_player_1.DeviceInfo));
exports.BrowserInfo = BrowserInfo;
